import { render, staticRenderFns } from "./ModalAddPromo.vue?vue&type=template&id=9a715d08&"
import script from "./ModalAddPromo.vue?vue&type=script&lang=js&"
export * from "./ModalAddPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports